import Spinner from "./QuarterCircle";

export default Spinner;
